import { Api } from "@noom/noomscape";

import { DEFAULT_ADDRESS } from "@/constants";
import { Address } from "@/models";

/**
 * The address validation service omits null address fields.
 * We spread DEFAULT_ADDRESS so all fields are present when saving to the backend.
 */
export const validateAndGetCorrectedAddress = async (
  address: Address,
): Promise<Address> =>
  Api.call("address.validate", Api.api.address.validate, { address })
    .then((correctedAddress: Address) => ({
      ...DEFAULT_ADDRESS,
      ...correctedAddress,
    }))
    .catch(() => address);
